import React, {Component} from 'react';
import {Grid} from 'material-ui';
import './styles.css';

class ColorPicker extends Component {
    state = {
        isOpen: false,
        selectedColor: {},
    };

    componentWillReceiveProps(nextProps) {
        const {sectionBgColorId, colors} = nextProps;

        if (sectionBgColorId && colors.length) {
            this.setState({
                selectedColor: {
                    background: colors.find(
                        (color) => color.id === sectionBgColorId
                    ).bg_color,
                },
            });
        }
    }

    handleOpenPopup = () => {
        this.setState({isOpen: !this.state.isOpen});
    };

    handlePickColor = (id) => {
        const {isOpen} = this.state;
        const {colors} = this.props;

        const selectedColor = {
            background: colors.find((color) => color.id === id).bg_color,
        };

        this.setState({isOpen: !isOpen, selectedColor});

        this.props.onChangeSectionBgColor(id);
    };

    renderColors = () => {
        const {colors, sectionBgColorId} = this.props;

        return (
            <div className="colors">
                {colors.map((bgColor) => {
                    const {bg_color, id} = bgColor;

                    const border =
                        id === sectionBgColorId
                            ? {border: '3px solid #bbb'}
                            : {border: '1px solid #bbb'};

                    return (
                        <span
                            key={id}
                            style={{
                                background: bg_color,
                                ...border,
                            }}
                            onClick={(ev) => this.handlePickColor(id)}
                        />
                    );
                })}
            </div>
        );
    };

    render() {
        const {classes} = this.props;
        const {selectedColor, isOpen} = this.state;

        return (
            <Grid container spacing={0} className={classes.pbSectionCaption}>
                <Grid item xs={12}>
                    <Grid container direction="row" spacing={0}>
                        <div
                            className="colorPicker"
                            style={selectedColor}
                            onClick={this.handleOpenPopup}
                        >
                            Background Color
                        </div>
                        {isOpen && this.renderColors()}
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/colorPicker/color_picker.js